import * as S from "sanctuary";
import { v4 as uuidv4 } from "uuid";

const DEFAULT_ALERT_TTL = 5000;
export { ALERT_LEVELS } from "@/components/generic/Alert";

export const REMOVE_ALERT = "alerts/REMOVE_ALERT";
export const removeAlert = ({ id }) => ({
  type: REMOVE_ALERT,
  payload: {
    id,
  },
});

// passing ttl: S.Nothing would signify that the alert will not
// automatically be removed.
// not passing a ttl will default to a ttl of 5000
export const CREATE_ALERT = "alerts/CREATE_ALERT";
export const createAlert = ({
  type,
  title,
  text,
  ttl = S.Just(DEFAULT_ALERT_TTL),
}) => ({
  type: CREATE_ALERT,
  payload: {
    alert: {
      id: uuidv4(),
      type,
      title,
      text,
      ttl,
    },
  },
});

// Empties the whole alert stack at once. The transaction search epics emit
// this when a search is submitted or re-submitted, so notices raised for a
// previous search never outlive the search they describe.
export const CLEAR_ALL_ALERTS = "alerts/CLEAR_ALL_ALERTS";
export const clearAllAlerts = () => ({
  type: CLEAR_ALL_ALERTS,
});

export const ALERT_CREATED = "alerts/ALERT_CREATED";
export const alertCreated = ({ id, type, title, text, ttl }) => ({
  type: ALERT_CREATED,
  payload: {
    alert: {
      id,
      type,
      title,
      text,
      ttl,
    },
  },
});

const INITIAL_STATE = {
  alerts: [],
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case ALERT_CREATED:
      return {
        alerts: [...state.alerts, payload.alert],
      };
    case REMOVE_ALERT:
      return {
        alerts: state.alerts.filter((alert) => alert.id !== payload.id),
      };
    case CLEAR_ALL_ALERTS:
      return state.alerts.length === 0 ? state : { alerts: [] };
    default:
      return state;
  }
};

const getState = (state) => state.alerts;
export const getAllAlerts = (state) => getState(state).alerts;

export default reducer;
